module.exports = __webpack_public_path__ + "static/bg.3a4521f9.png";